import * as React from 'react';
import { List, Row, Col, Collapse, Button, message, Popconfirm, notification, Tooltip, Icon, Card } from 'antd';
import { Cart, CartItem } from 'Core/Api/Kopp/Api';
import moment from 'moment';
import CartContext from 'Context/CartContext';
import { NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import { PageContainerRow, PageContainerCol, PageContainerColLayout, BorderlessCollapse } from './CartOverviewView.Style';
import { CargesModel } from 'components/CargoCharges/CargoChargesResults/CargoChargesResultsModel';
import Table, { ColumnProps } from 'antd/lib/table';
import { CartHandler } from '../CartHandler';
import CartItemListItem from '../CartItemListItem';
import { RightAlignRow } from 'components/Styled/Layout.Styled';
import CardRegistrationNotificationView from 'components/Payment/CardRegistrationNotificationView';
import { AuthUser } from 'Core/models/AuthUser';
import { CreditCardRegistrationFormHandler } from 'components/UserManagement/Profile/CreditCardRegistrationForm/CreditCardRegistrationFormHandler';
import NotificationUtility from 'Core/NotificationUtility';
export interface Props extends RouteComponentProps {
  children?: React.ReactNode;
  cart?: Cart;
  user?: AuthUser;
}

export interface State {
  cart?: Cart;
  isCardRegistered: boolean;
}

export class CartOverviewViewWithoutRouter extends React.Component<Props, State> {
  static contextType = CartContext;
  context!: React.ContextType<typeof CartContext>;
  handler: CartHandler;
  creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;

  constructor(props: Props) {
    super(props);
    this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
    this.getRegisteredCards = this.getRegisteredCards.bind(this);

    this.state = {
      cart: props.cart,
      isCardRegistered: false,
    };

    this.renderCartItem = this.renderCartItem.bind(this);
    this.renderTotalFooter = this.renderTotalFooter.bind(this);
    this.handler = new CartHandler(props);
    this.updateCart = this.updateCart.bind(this);
    this.GoToCheckoutPage = this.GoToCheckoutPage.bind(this);
    this.emptyCart = this.emptyCart.bind(this);
  }

  componentDidUpdate(prevProps: Props, pervState: State) {
  }

  componentDidMount() {
    this.getRegisteredCards();
    this.handler.GetCart().then(x => {
      this.context.Update(x?.cart);
    }).catch(() => { });

  }

  updateCart(cart?: Cart) {
    this.context.Update(cart);
  }

  emptyCart() {
    this.handler.EmptyCart()
      .then(x => {
        this.context.Update(x.cart);
        NotificationUtility.info(
          'Cart Emptied',
          "All items in the cart was successfully removed.",
          25,
          true
        );
      }).catch(() => {
        NotificationUtility.error(
          'Issue Removing Items',
          "An error occurred while trying to empty the cart.",
          25,
          true
        );
      });
  }

  GoToCheckoutPage() {
    this.props.history.replace('/checkout');
  }

  renderCartItem(cartItem: CartItem) {
    return (
      <CartItemListItem cartItem={cartItem} updateCart={this.updateCart} />
    );
  }

  renderTotalFooter() {

    if (!this.context?.data?.cartItems?.length) {
      return <></>
    }

    return (
      <Row>
        <Col style={{ textAlign: "left", fontSize: "1.5em", borderBottom: "1px grey double" }} span={16}>Total Cost</Col>
        <Col style={{ textAlign: "right", fontSize: "1.5em", borderBottom: "1px grey double" }} span={8}>JMD$ {this.context?.data?.total}</Col>
      </Row>
    )
  }

  getRegisteredCards() {
    if (this.props.user?.id) {
      this.creditCardRegistrationFormHandler
        .GetRegisteredCreditCard(this.props.user.id)
        .then(x => {
          if (x.filter(card => card.id).length > 0) {
            this.setState({ isCardRegistered: true });
          }
        }).catch(x => { });
    }
  }

  waitMessage = (
    <div>
      {/* <h3>Please wait</h3> */}
      <p>Currently doing checks in the background</p>
    </div>
  );

  render() {
    const cart = this.context?.data || new Cart();

    var checkoutButton;
    if (this.state.isCardRegistered && cart.cartItems !== undefined) {
      if (cart.cartItems?.length > 0)
        checkoutButton = <Button style={{ backgroundColor: "#77DD2E", color: "white" }} type="default" onClick={this.GoToCheckoutPage}>Pay Now</Button>
    }
    else
      checkoutButton = <Tooltip placement="top" title={this.waitMessage}> <Button style={{ backgroundColor: "#77DD2E", color: "white" }} type="default" onClick={this.GoToCheckoutPage} disabled >Pay Now</Button>      <Icon type="info-circle" />

      </Tooltip>

    return (
      <>
        <Row style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
          <Row>
            <Col>
              <p>
                You have {cart.cartItems?.length || "no"}  {cart.cartItems?.length !== undefined && cart.cartItems?.length !== 1 ? "items" : "item"} in the cart.
                if you wish to add more items to the cart you can do so on the <NavLink to="/charges">Get &amp; Pay Charges</NavLink> page.
              </p>
            </Col>
          </Row>
          <RightAlignRow>
            <Col>
              {cart?.cartItems?.length ? <Popconfirm
                title="Are you sure you with to remove all items from the cart?"
                onConfirm={this.emptyCart}
                okText="Yes"
                cancelText="No"
              ><Button style={{ backgroundColor: "#FF6232", color: "white" }} >Empty Cart</Button>
              </Popconfirm>
                : <></>}
            </Col>
          </RightAlignRow>
          <p> </p>
          <Row>
            <Col>
              <Card
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.0)',
                  borderRadius: '15px',
                  overflow: 'hidden'
                }}
              >
                <List footer={this.renderTotalFooter()} itemLayout="horizontal" dataSource={cart.cartItems} renderItem={this.renderCartItem} />
              </Card>
            </Col>
          </Row>
          <p> </p>
          <Row type="flex" justify="end" >
            <Col>
              {checkoutButton}
            </Col>
          </Row>
          <CardRegistrationNotificationView showAgainForSesion={true} />
        </Row>
      </>
    )
  }
}

const CartOverviewView = withRouter(CartOverviewViewWithoutRouter);

export default CartOverviewView;